module.exports = __webpack_public_path__ + "images/emails/b-take-survey-c7b74834.gif";